var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 14.328a.681.681 0 01-.681-.68V9.56a.681.681 0 011.362 0v4.086a.681.681 0 01-.681.681z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5.589L4.53 18.528h14.94L12 5.589zm.983-1.022a1.135 1.135 0 00-1.966 0l-7.863 13.62c-.437.757.109 1.703.983 1.703h15.726c.874 0 1.42-.946.983-1.703l-7.863-13.62z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.135 16.485a1.135 1.135 0 11-2.27 0 1.135 1.135 0 012.27 0z",
    fill: "currentColor"
  })));
}
export default SvgError;